import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, references } from '@apexdesigner/schema-tools';

export const groupMatch = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    groupName: z
      .string()
      .describe(
        "The group's name when the run was made, kept if the group is renamed or deleted.",
      ),

    mareSizeInfluence: z
      .number()
      .describe(
        "Weight of the mare in each foal's size, as a percentage (usually 55).",
      ),

    sirePatternInfluence: z
      .number()
      .describe(
        "Weight of the sire in each foal's pattern, as a percentage (usually 55).",
      ),

    seed: z
      .number()
      .nullable()
      .optional()
      .describe(
        'Random seed every pair used, from 0 to 40; unknown for loaded legacy runs.',
      ),

    runTimestamp: z.coerce.date().describe('When the group was run.'),

    legacyId: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .describe(
        'The legacy `user_groups_master.id`, for runs loaded from the old system.',
      ),

    horseId: z.number().presentAs('reference').describe('Foreign key to Horse'),

    groupId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to HorseGroup'),

    runById: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    horse: references('Horse'),

    group: references('HorseGroup'),

    runBy: references('User'),

    entries: hasMany('GroupMatchEntry'),
  })
  .describe(
    "One run of a mare against a stallion group, or a stallion against a mare\ngroup: the horse, the group, the influences and seed every pair used, and\nwho ran it and when. Each pair's match is linked through a group match\nentry.",
  )
  .meta({ readAs: '{horse} × {groupName}' })
  .as('GroupMatch');

export { groupMatch as groupMatchSchema };
